/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import "../../assets/scss/datatables.scss"

const DPImagePop = (props) => {

    return (
        <div>
            <Modal
                size="md"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody className="text-center"> {/* Center align the content */}
                                    <CardTitle className="h4">{props.SubTitle}</CardTitle>
                                    <img
                                        src={props.ImgSrc}
                                        alt="Description of the image"
                                        className="mx-auto" // Center align the image horizontally
                                        style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>

            </Modal>
        </div>
    );
}

export default DPImagePop;